import React, { useState, useRef, useEffect } from 'react';
import { parseHtmlEntities, debounce } from '@variables/utils';
import {
  StyledSelectBox,
  StyledSelectButton,
  StyledSelectContents,
  StyledSearchInput,
  StyledSearchList,
  StyledResetBtn,
} from '@components/atoms/Inputs/SelectSearchDicomTag/style';

interface dicomType {
  definition: string;
  id: number;
  tag: string;
  tagIdx?: number;
  difinitionIdx?: number;
  keyworkNum?: number;
}

const SelectSearchDicomTag = ({ dicomTagList, value, dataIdx, onChangeFunc, resetChangeFunc }: any) => {
  const [isOpen, setIsOpen] = useState(false);
  const [dicomFilterList, setDicomFilterList] = useState<dicomType[]>([]);
  /**
   * 필터 디바운스
   */
  const debounceFilter = debounce((value: any) => {
    filterDicomTag(value);
  }, 500);

  /**
   * dicom search filter
   * @param e
   */
  const filterDicomTag = (e?: string) => {
    if (!e) {
      setDicomFilterList([]);
      return;
    }
    let _filter: any = [];
    // 입력 데이터 소문자 치환
    const inputText = e.toLowerCase();

    // 데이터 가공
    dicomTagList.forEach((data: dicomType) => {
      // tag 구분자 삽입 및 keyword 위치 확인후 데이터 가공
      if (data.tag.indexOf(',') === -1) {
        data.tag = data.tag.substring(0, 4) + ',' + data.tag.substring(4, data.tag.length + 1);
      }

      // html 문자 디코딩
      data.definition = parseHtmlEntities(data.definition);
      // tag 정보 소문자 치환
      const definitionLowerCase = data.definition.toLowerCase();

      // keyword idx , length
      data.tagIdx = data.tag.indexOf(inputText);
      data.difinitionIdx = definitionLowerCase.indexOf(inputText);
      data.keyworkNum = e.length;

      if (data.tagIdx > -1 || data.difinitionIdx > -1) {
        _filter.push(data);
      }
    });
    setDicomFilterList(_filter);
  };

  /**
   * keyword 강조 반환
   */
  const keywordList = (data: any) => {
    const tagString = makeKeyword(data.tag, data.tagIdx, data.keyworkNum);
    const difiString = makeKeyword(data.definition, data.difinitionIdx, data.keyworkNum);
    return (
      <>
        ({tagString.fstString}
        <em className="keyword">{tagString.keyString}</em>
        {tagString.endString}) &nbsp;{difiString.fstString}
        <em className="keyword">{difiString.keyString}</em>
        {difiString.endString}
      </>
    );
  };

  /**
   * 키워드 조합 생성
   * @param keyword
   * @param idx
   * @param keyNum
   */
  const makeKeyword = (keyword: string, idx: number, keyNum: number) => {
    let fstString = keyword;
    let keyString,
      endString = '';

    // tag 키워드 생성
    if (idx > -1 && keyNum) {
      fstString = idx === 0 ? '' : keyword.substring(0, idx);
      keyString = keyword.substring(idx, idx + keyNum);
      endString = keyword.substring(idx + keyNum, keyword.length);
    }

    return { fstString, keyString, endString };
  };

  /**
   * 자신 이외 선택시 close
   */
  const dropDownEl = useRef<any>(null);

  const handleClickOutside = ({ target }: MouseEvent) => {
    if (target) {
      if (isOpen && !dropDownEl.current?.contains(target)) {
        setIsOpen(false);
      }
      if (isOpen && !dropDownEl.current?.contains(target)) {
        setIsOpen(false);
      }
    }
  };

  useEffect(() => {
    window.addEventListener('click', handleClickOutside);
    return () => {
      window.removeEventListener('click', handleClickOutside);
    };
  });

  return (
    <>
      <StyledSelectBox ref={dropDownEl}>
        <StyledSelectButton
          className={`${isOpen ? 'open' : ''} ${value.definition && 'has-value'}`}
          onClick={() => {
            filterDicomTag('');
            setIsOpen(!isOpen);
          }}
        >
          {value.definition ? parseHtmlEntities(value.definition) || 'Metatag' : 'Metatag'}
        </StyledSelectButton>
        {isOpen && (
          <StyledSelectContents>
            <StyledSearchInput>
              <input type="text" onChange={(e) => debounceFilter(e.target.value)} />
              <button className="btn-search"></button>
            </StyledSearchInput>
            <StyledSearchList>
              {dicomFilterList.map((data, index) => {
                keywordList(data);
                return (
                  <li
                    key={index}
                    onClick={() => {
                      onChangeFunc(data, dataIdx, 'TAG');
                      setIsOpen(!isOpen);
                    }}
                  >
                    {keywordList(data)}
                  </li>
                );
              })}
            </StyledSearchList>
          </StyledSelectContents>
        )}
        {resetChangeFunc && <StyledResetBtn onClick={resetChangeFunc}></StyledResetBtn>}
      </StyledSelectBox>
    </>
  );
};
export default SelectSearchDicomTag;
